import {IStation} from '../api/api.types';
import {StateService, Transition} from 'angular-ui-router';

export default class StationManagerController {
  static $inject = ['$state', '$rootScope', '$transitions'];

  private station: IStation;
  private stateName: string;

  constructor(
    private $state:StateService,
    private $rootScope:ng.IRootScopeService,
    private $transitions: Transition) {

    this.$rootScope.$on('STATION_LOADED', (event, station) => {
      this.station = station;
    });

    this.stateName = this.$state.current.name;

    this.$transitions.onSuccess({}, () => {
        this.stateName = this.$state.current.name;
    })
  }
}


/** WEBPACK FOOTER **
 ** ./app/station/station.controller.ts
 **/